// components/SelectTimeRange.tsx
import { addDays, subDays, subMonths, subYears } from "date-fns"

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

export type TimeRangeOption = {
  label: string
  value: string
}

export const timeRangeOptions = (): TimeRangeOption[] => {
  const now = new Date()
  return [
    {
      label: "Today",
      value: "1",
    },
    {
      label: "3 Days",
      value: "3",
    },
    {
      label: "7 Days",
      value: "7",
    },
    {
      label: "15 Days",
      value: "15",
    },
    {
      label: "1 Month",
      value: "30",
    },
    {
      label: "3 Months",
      value: "90",
    },
    {
      label: "6 Months",
      value: "180",
    },
    {
      label: "1 Year",
      value: "365",
    },
  ]
}

type SelectTimeRangeProps = {
  range: {
    label: string
    value: string
  }
  setRange: (range: TimeRangeOption) => void
}

export default function SelectTimeRange({
  range,
  setRange,
}: SelectTimeRangeProps) {
  const options = timeRangeOptions()

  return (
    <Select
      value={range.value}
      onValueChange={(val) => {
        const selected = options.find((opt) => opt.value === val)
        if (selected) {
          setRange(selected)
        }
      }}
    >
      <SelectTrigger className="w-[130px]">
        <SelectValue placeholder="Select time range" />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem
            key={option.value}
            value={option.value}
            className={`relative flex items-center justify-center py-2 pl-0 pr-0 after:absolute after:bottom-1 after:h-[1px] after:w-[80%] after:bg-gray-300 data-[state=checked]:bg-[#00B7AE] data-[state=checked]:text-white`}
          >
            <span className="w-full text-center">{option.label}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
